export default class SendErrorCardRenderAnalytics {
  constructor(context) {
    this.context = context;
  }

  run(renderEventData = {}) {
    this.context.analytics.track('AppCard Error Rendered', { ...renderEventData });
  }
}
